export const getSocialServiceOffersFrag = `
    id
    code
    color
    name
    unit
    payment
    unitPrice
    unitPriceExt
    usualWorkGroup
    usualEmployment
    validFrom
    validTo
`;
